import { render, staticRenderFns } from "./RegistrarEmpresa.vue?vue&type=template&id=7e6e4508&"
import script from "./RegistrarEmpresa.vue?vue&type=script&lang=js&"
export * from "./RegistrarEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports